module.exports = __webpack_public_path__ + "img/OverseaMember59.1de05df3.jpg";